module.exports = __webpack_public_path__ + "img/login_banner_mobile.c157d7cd.png";